export const AllInConditionals = (superclass) => class extends superclass {
    _isAdmin(org = false) {
        if (!org) {
            org = this._getOrganisationById(this.currentOrg);
        }
        return this._isRole('ADMIN', org);
    }
    _isManagement(org = false) {
        if (!org) {
            org = this._getOrganisationById(this.currentOrg);
        }
        return this._isRole('MANAGER', org) || this._isRole('ADMIN', org);
    }
    _isRole(role, org) {
        if (!org.hasOwnProperty.role) {
            if (!org.users?.users) {
                return false;
            }
            let currentUser = org.users?.users.find(user => user.id === this.user.id);
            org.role = currentUser?.role;
            this.organisation = org;
            if (this._updateContext !== undefined) {
                this._updateContext({ organisation: org });
            }
            else {
                this.context = { ...this.context, organisation: this.organisation };
                this._provider.setValue(this.context);
            }
            return org.role === role;
        }
        else {
            return org.role === role;
        }
    }
    _hasApproval(org = false) {
        if (!org) {
            org = this._getOrganisationById(this.currentOrg);
        }
        this.hasApproval = this.currentOrg && org?.approvalStatus == 'Approved';
        return this.hasApproval;
    }
    _isPilot(org = false) {
        if (!org) {
            org = this._getOrganisationById(this.currentOrg);
        }
        this.isPilot = org?.pilot ?? false;
        return this.isPilot;
    }
    _getTier(org = false) {
        if (!org) {
            org = this._getOrganisationById(this.currentOrg);
        }
        if (org?.subscriptionTier) {
            return org.subscriptionTier;
        }
        else {
            return 'Tier1'; // Default to Tier1 if not set
        }
    }
    _isOnboarded() {
        let org = this._getOrganisationById(this.currentOrg);
        return org?.locations?.length;
    }
    _setProfilesTypes() {
        let org = this._getOrganisationById(this.currentOrg);
        this.hasSupportProfile = false;
        this.hasCulturalProfile = false;
        this.hasAnalyticsProfile = false;
        this.hasProxyProfile = false;
        if (org?.profiles) {
            org.profiles.forEach(profile => {
                if (profile.type === 'support') {
                    this.hasSupportProfile = true;
                }
                else if (profile.type === 'cultural') {
                    this.hasCulturalProfile = true;
                }
                else if (profile.type === 'analytics') {
                    this.hasAnalyticsProfile = true;
                }
                else if (profile.type === 'proxy') {
                    this.hasProxyProfile = true;
                }
            });
        }
    }
};
